import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notificationController } from 'infrastructure/antd/controllers/notification-controller';
import { useTranslation } from 'react-i18next';
import dataService, { type IResponse } from 'services/dataService';
import { apiCompleteTask } from 'services/dataService/resources/oneplatform/api';

import { QUERY_KEYS } from '../constants';

export function useCompleteDashboardTask() {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: (taskGuid: string) =>
      dataService.createOne(apiCompleteTask(taskGuid), {}),
    onSuccess: (response: IResponse<unknown>) => {
      if (response.error) {
        notificationController.error({
          message: t('tasksDashboard.completeError'),
        });
        if (response.status === 409) {
          queryClient.invalidateQueries({
            queryKey: [QUERY_KEYS.dashboardTasks],
            exact: false,
            refetchType: 'active',
          });
        }
        return;
      }

      notificationController.success({
        message: t('tasksDashboard.completeSuccess'),
      });
      queryClient.invalidateQueries([QUERY_KEYS.dashboardTasks]);
      queryClient.invalidateQueries([QUERY_KEYS.tasksBadgeCount]);
    },
  });
}
